// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iEPH","colMin":"styles_colMin__3wcT_"};